import angular from 'angular';

angular.module('cloudX').directive('validateTextField', [
  '$parse',
  function($parse) {
    return {
      restrict: 'A',
      require: ['ngModel', '^?bindErrors'],
      link: function(scope, element, attributes, ctrls) {
        var ngModel = ctrls[0];
        var bindErrors = ctrls[1];

        attributes.$observe('validateTextField', function(value) {
          if (!value) return;
          var fieldDef = scope.$eval(value);
          if (!fieldDef || !fieldDef.validators || !fieldDef.validators.length) return;
          for (var i = 0; i < fieldDef.validators.length; i++) {
            var validator = fieldDef.validators[i];
            if (!validator) continue;
            if (validator.maximum !== null) {
              if (bindErrors) bindErrors.addError('maxLength', 8, [validator.maximum]);
              ngModel.$validators.maxLength = (function(max) {
                return function(modelValue) {
                  if (modelValue === null) return true;
                  if (modelValue.length <= Number(max)) return true;
                  return false;
                };
              })(validator.maximum);
            }

            if (validator.minimum !== null) {
              if (bindErrors) bindErrors.addError('minLength', 7, [validator.minimum]);
              ngModel.$validators.minLength = (function(min) {
                return function(modelValue) {
                  if (modelValue === null) return true;
                  if (modelValue.length >= Number(min)) return true;
                  return false;
                };
              })(validator.minimum);
            }
            if (validator.regularExpression !== null && validator.regularExpression.length) {
              if (bindErrors) bindErrors.addError('pattern', 9, [fieldDef.id]);
              ngModel.$validators.pattern = (function(regex) {
                return function(modelValue) {
                  if (modelValue === null) return true;
                  if (typeof modelValue === 'undefined') return false;
                  if (!modelValue.length) return true; //Empty strings are valid
                  //Only test regex if there is a value
                  if (regex.test(modelValue)) return true;
                  return false;
                };
              })(new RegExp(validator.regularExpression));
            }
          }
        });
        //if (bindErrors) {
        //    ngModel.$viewChangeListeners.push(function () {
        //        bindErrors.refreshErrors(ngModel.$error);
        //    });
        //    scope.$on('$destroy', function () {
        //        bindErrors.refreshErrors();
        //    });
        //}
      },
    };
  },
]);
